import React from 'react';
import { createRoot } from 'react-dom/client';
import './lang/i18n';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<App />);
